declare global {
  interface Window {
    cookieConsentJson: CookieConsentJSON | [] | {}
  }
}

interface CookieConsentJSON {
  'decline-button-text'?: string | null
  'accept-button-text'?: string | null
  'title-text-html'?: string | null
  'body-text-html'?: string | null
  'cookie-name'?: string | null
  'container-class-name'?: string | null
  'event-name'?: string | null
  color?: string | null
  'deny-page-href'?: string | null
  'settings-accept-button'?: string | null
  'settings-title-text-html'?: string | null
  'settings-body-text-html'?: string | null
  settings?: CookieSetting[] | null
}

export interface CookieConsentOptions {
  declineButtonText: string
  acceptButtonText: string
  titleTextHtml: string
  bodyTextHtml: string
  cookieName: string
  containerClassName: string
  eventName: string
  color: string
  denyPageHref: string
}

interface CookieSetting {
  id: string
  title: string
  content: string
}

export interface CookieSettingsOptions {
  settings: CookieSetting[]
  settingsAcceptButton: string
  settingsTitleTextHtml: string
  settingsBodyTextHtml: string
  color: string
}

export default function (): {
  cookieConsentOptions: CookieConsentOptions
  cookieSettingsOptions: CookieSettingsOptions
} | null {
  const options = window.cookieConsentJson
  if (!options || options === [] || options === {}) return null

  const ccOptions = options as CookieConsentJSON
  const declineButtonText = ccOptions['decline-button-text'] || '',
    acceptButtonText = ccOptions['accept-button-text'] || '',
    titleTextHtml = ccOptions['title-text-html'] || '',
    bodyTextHtml = ccOptions['body-text-html'] || '',
    cookieName = ccOptions['cookie-name'] || '',
    containerClassName = ccOptions['container-class-name'] || '',
    eventName = ccOptions['event-name'] || '',
    color = ccOptions.color || '',
    denyPageHref = ccOptions['deny-page-href'] || '',
    settings = ccOptions['settings'] || [],
    settingsAcceptButton = ccOptions['settings-accept-button'] || '',
    settingsBodyTextHtml = ccOptions['settings-body-text-html'] || '',
    settingsTitleTextHtml = ccOptions['settings-title-text-html'] || ''

  const cookieConsentOptions = {
    declineButtonText,
    acceptButtonText,
    titleTextHtml,
    bodyTextHtml,
    cookieName,
    containerClassName,
    eventName,
    color,
    denyPageHref,
  }

  const cookieSettingsOptions = {
    settings,
    settingsAcceptButton,
    settingsBodyTextHtml,
    settingsTitleTextHtml,
    color,
  }

  return { cookieConsentOptions, cookieSettingsOptions }
}
